import useWindowSize from './useWindowSize';

const PHONE_MAX = 576;
const TABLET_MAX = 900;

function useResponsive() {
  const { width, height } = useWindowSize();

  return {
    width,
    height,
    isPhone: width < PHONE_MAX,
    isTablet: width >= PHONE_MAX && width < TABLET_MAX,
    isDesktop: width >= TABLET_MAX,
    isMobile: width < TABLET_MAX,
    isPortrait: height > width,
    breakpoint: width < PHONE_MAX ? 'phone' : width < TABLET_MAX ? 'tablet' : 'desktop',
  };
}

export { PHONE_MAX, TABLET_MAX };
export default useResponsive;
